import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat"
import timezone from 'dayjs/plugin/timezone';
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat)
dayjs.extend(timezone)
dayjs.extend(utc);

const tz = "America/Sao_Paulo"
export const dayJsFormataData = (
    date: Date | string | null,
    format: string = "DD/MM/YYYY HH:mm"
) => {
    if (date === null || date === "") {
        return null;
    }

    return dayjs(date).format(format);
};


export const gDt = () => dayjs().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss');

export const getDurationFromNow = (date: Date | string | null, format: string = "DD/MM/YYYY HH:mm:ss") => {
        let date1 = dayjs(date, format)
        let date2 = dayjs()
        return date2.diff(date1, 'seconds')
}

export const dayjsFrom = (
    date: Date | string | null,
    format: string = "DD/MM/YYYY HH:mm"
) => {
    return dayjs(date, format)
}


export const secondsToTime = (secs:number) => {
    if (isNaN(secs)) {
        return secs;
    }

    let s = secs % 60;
    let m = Math.floor(secs / 60) % 60;
    let h = Math.floor(secs / 3600) % 60;

    let hour = String(h);

    if (String(h).length < 2) {
        hour = ("0" + h).slice(-2);
    }

    return `
            ${("0" + m).slice(-2)}:${("0" + s).slice(-2)}`;
}
